import { createReducer, on } from '@ngrx/store';
import { clearAppSession, hydrateAppSession, setAppSession } from './app-session.actions';
import { initialAppSessionState } from './app-session.state';

export const appSessionReducer = createReducer(
    initialAppSessionState,
    on(setAppSession, (state, { session }) => ({ ...session })),
    on(hydrateAppSession, (state, { session }) => ({ ...session })),
    on(clearAppSession, () => null),
);
